document.addEventListener('rebuy:smartcart.ready', () => {
  const defaultDiscountPercentage = window.discountPercentage || 0;

  let discountPercentage = window.discountPercentage || 0;
  let isInitialized = false;

  function updatePrices(discountPercentage, priceInfo = null) {
    function calculateDiscountedPrice(originalPrice, discountPercentage) {
      return originalPrice * (1 - discountPercentage / 100);
    }

    function formatPrice(price) {
      const formattedPrice = '$' + Math.abs(price).toFixed(2);
      return formattedPrice.endsWith('.00') ? formattedPrice.slice(0, -3) : formattedPrice;
    }

    function parsePrice(priceString) {
      const matches = priceString.match(/(\d+(?:\.\d{1,2})?)/g);
      if (matches && matches.length > 0) {
        const prices = matches.map((match) => parseFloat(match));
        return Math.max(...prices);
      }
      return NaN;
    }

    // Update buttons with class 'gtm-add-to-cart'
    const addToCartButtons = document.querySelectorAll('.gtm-add-to-cart');
    addToCartButtons.forEach((button) => {
      // ✅ ADD THIS CHECK
    if (button.closest('[data-exclude-strikethrough="true"]')) return;

      const quickPriceElement = button.querySelector('.quick-price');
      const linkStrikeElement = button.querySelector('.link__strike');
      const finalPriceElement = button.querySelector('.link__finalPrice');
      const linkDivider = button.querySelector('.link__divider');
      const linkPriceTitle = button.querySelector('.link__priceTitle');
      const skioOnetimeElement = button.querySelector('[skio-onetime-price]');

      function preserveSeparator() {
        if (!linkDivider) {
          const divider = document.createElement('span');
          divider.className = 'link__divider';
          divider.innerHTML = '&nbsp;−&nbsp;';
          if (linkPriceTitle) {
            linkPriceTitle.insertAdjacentElement('afterend', divider);
          }
        }
      }

      if (skioOnetimeElement) {
        // --- CASE 1: ONE-TIME PURCHASE IS ACTIVE IN THE BUTTON ---
        const regularPriceElement = skioOnetimeElement.querySelector('.regular-price s');
        const salePriceElement = skioOnetimeElement.querySelector('.sale-price');
        if (!regularPriceElement || !salePriceElement) return;

        const originalPrice = parsePrice(regularPriceElement.textContent.trim());
        if (isNaN(originalPrice)) return;

        const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercentage);
        salePriceElement.textContent = formatPrice(discountedPrice);
      
      } else if (button.querySelector('.regular-price s') && button.querySelector('.sale-price')) {
        // --- CASE 2 (NEW): SUBSCRIPTION IS ACTIVE IN THE BUTTON ---
        // This block handles updating the button price on cart changes when it's in the subscription state.
        const regularPriceElement = button.querySelector('.regular-price s');
        const salePriceElement = button.querySelector('.sale-price');

        // Get the original price from the strikethrough text
        const originalPrice = parsePrice(regularPriceElement.textContent.trim());
        if (isNaN(originalPrice)) return;
        
        // Calculate the new discounted price and update the sale price element
        const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercentage);
        salePriceElement.innerHTML = `<span>&nbsp;</span>${formatPrice(discountedPrice)}`;
      } else if (quickPriceElement) {
        const priceText = quickPriceElement.textContent.trim();
        const originalPrice = parsePrice(priceText);
        if (isNaN(originalPrice)) return;
        const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercentage);
        quickPriceElement.innerHTML = ' - <s>' + formatPrice(originalPrice) + '</s>';
        const discountedPriceElement = document.createElement('span');
        discountedPriceElement.className = 'discounted-price';
        discountedPriceElement.textContent = ' ' + formatPrice(discountedPrice);
        quickPriceElement.appendChild(discountedPriceElement);
      } else if (linkStrikeElement && finalPriceElement) {
        const originalPriceText = linkStrikeElement.textContent.trim();
        const originalPrice = parsePrice(originalPriceText);
        if (isNaN(originalPrice)) return;
        const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercentage);
        linkStrikeElement.textContent = formatPrice(originalPrice);
        finalPriceElement.innerHTML = '&nbsp;' + formatPrice(discountedPrice);
        preserveSeparator();
      } else if (finalPriceElement) {
        const priceText = finalPriceElement.textContent.trim();
        const originalPrice = parsePrice(priceText);
        if (isNaN(originalPrice)) return;
        const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercentage);
        const strikeElement = document.createElement('s');
        strikeElement.className = 'link__strike';
        strikeElement.textContent = formatPrice(originalPrice);
        finalPriceElement.insertAdjacentElement('beforebegin', strikeElement);
        finalPriceElement.innerHTML = '&nbsp;' + formatPrice(discountedPrice);
        preserveSeparator();
      } else {
        return;
      }
    });

    // Update elements with class 'product__price' (remains unchanged from original)
    const priceElements = document.querySelectorAll('.product__price');
    priceElements.forEach((priceElement) => {
      // ✅ ADD THIS CHECK
    if (priceElement.closest('[data-exclude-strikethrough="true"]')) return;

      let strikeElement = priceElement.querySelector('.strike s');
      const discountedPriceElement = priceElement.querySelector('#product-price');
      if (!discountedPriceElement) return;
      let originalPrice = NaN;
      if (strikeElement) {
        const strikePriceText = strikeElement.textContent.trim();
        originalPrice = parsePrice(strikePriceText);
      } else {
        const priceText = discountedPriceElement.textContent.trim();
        originalPrice = parsePrice(priceText);
      }
      if (isNaN(originalPrice)) return;
      const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercentage);
      if (!strikeElement) {
        const strikeSpan = document.createElement('span');
        strikeSpan.className = 'strike';
        const sElement = document.createElement('s');
        sElement.textContent = formatPrice(originalPrice);
        strikeSpan.appendChild(sElement);
        discountedPriceElement.insertAdjacentElement('beforebegin', strikeSpan);
      } else {
        strikeElement.textContent = formatPrice(originalPrice);
      }
      discountedPriceElement.textContent = formatPrice(discountedPrice);
    });


    // =================================================================
    // Rebuy smart cart upsell products 
    // =================================================================
    /* const rebuyCrossSellPrices = document.querySelectorAll('[data-rebuy-id="197754"] .rebuy-product-price');

    rebuyCrossSellPrices.forEach((priceContainer) => {
      const displayContainer = priceContainer.querySelector('div');
      if (!displayContainer) return;

      // Prevent re-running on already modified prices
      if (displayContainer.querySelector('s')) return;

      const originalPriceText = displayContainer.textContent.trim();
      const originalPrice = parsePrice(originalPriceText);
      
      // Only run if the price is valid and there is a discount
      if (isNaN(originalPrice) || discountPercentage <= 0) return;

      const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercentage);

      const originalPriceFormatted = formatPrice(originalPrice);
      const discountedPriceFormatted = formatPrice(discountedPrice);
      
      // Update the HTML to show the original price struck out and the new discounted price
      displayContainer.innerHTML = `
        <span class="rebuy-money"><s>${originalPriceFormatted}</s></span>
        <span class="rebuy-money" style="margin-left: 5px;">${discountedPriceFormatted}</span>
      `;
    }); */


    // SHOP PAY INSTALLMENT PRICE BLOCK
    const shopifyPaymentTerms = document.querySelectorAll('shopify-payment-terms');

    shopifyPaymentTerms.forEach((term) => {
      // Exclude if the parent has the data-exclude attribute
      if (term.closest('[data-exclude-strikethrough="true"]')) return;

      const shadowRoot = term.shadowRoot;
      if (!shadowRoot) return;

      // ✅ NEW CHECK: Find the content container first
      const contentContainer = shadowRoot.querySelector('#shopify-installments-content');
      if (!contentContainer) return; // Exit if not found

      // ✅ NEW CHECK: If it's the "minimum order" message, skip.
      if (contentContainer.textContent.includes('orders over')) {
        return;
      }
      
      const priceElement = contentContainer.querySelector('.font-bold');
      if (!priceElement) return;
      
      let originalInstallmentPrice;
      
      // Find the original price, whether a strikethrough exists or not.
      const existingStrike = priceElement.querySelector('s');
      if (existingStrike) {
        // If a strikethrough exists, the original price is inside it.
        originalInstallmentPrice = parsePrice(existingStrike.textContent.trim());
      } else {
        // Otherwise, the original price is the text of the element.
        originalInstallmentPrice = parsePrice(priceElement.textContent.trim());
      }
      
      // If we couldn't find a valid price, stop.
      if (isNaN(originalInstallmentPrice)) {
        return;
      }
      
      // If discount is not active, ensure the original price is displayed correctly without a strikethrough.
      if (discountPercentage <= 0) {
        priceElement.innerHTML = formatPrice(originalInstallmentPrice);
        return;
      }

      // If we have a valid price and an active discount, proceed.
      const discountedInstallmentPrice = calculateDiscountedPrice(originalInstallmentPrice, discountPercentage);
      
      const formattedOriginal = formatPrice(originalInstallmentPrice);
      const formattedDiscounted = formatPrice(discountedInstallmentPrice);
      
      // Always overwrite the HTML.
      priceElement.innerHTML = `<s>${formattedOriginal}</s>&nbsp;${formattedDiscounted}`;
    });

    // START: UPDATE HIDDEN SHOP PAY MODAL PRICE
    // First, find the single product container on the page.
    const productContainer = document.querySelector('.product__block-container');

    // Check if that container exists AND has the exclusion attribute.
    if (productContainer && productContainer.hasAttribute('data-exclude-strikethrough')) {
      // Intentionally do nothing if the product is excluded.
    } else {
      // If the product is NOT excluded, proceed to find and update the modals.
      const shopPayModals = document.querySelectorAll('div[data-nametag="shop-portal-provider"]');

      shopPayModals.forEach((modal) => {
        const shadowRoot = modal.shadowRoot;
        if (!shadowRoot) return;

        // ✅ NEW CHECK: Find the subtitle container first
        const subtitleContainer = shadowRoot.querySelector('[data-testid="split-pay-subtitle"]');
        if (!subtitleContainer) return; // Exit if container not found

        // ✅ NEW CHECK: Check if it's the "minimum order" message
        if (subtitleContainer.textContent.includes('orders over')) {
          return; // Skip this modal
        }

        const priceElement = subtitleContainer.querySelector('.font-bold');
        // Exit only if the main price element isn't found.
        if (!priceElement) return; 

        let originalInstallmentPrice;

        // Intelligently find the original price, whether a strikethrough exists or not.
        const existingStrike = priceElement.querySelector('s');
        if (existingStrike) {
          // If a strikethrough already exists, the text inside it is our original price.
          originalInstallmentPrice = parsePrice(existingStrike.textContent.trim());
        } else {
          // If there's no strikethrough, the element's text is the original price.
          originalInstallmentPrice = parsePrice(priceElement.textContent.trim());
        }
        
        // If we couldn't parse a valid price, stop.
        if (isNaN(originalInstallmentPrice)) {
          return;
        }

        // If the discount is removed, restore the original price and remove the strikethrough.
        if (discountPercentage <= 0) {
          priceElement.innerHTML = formatPrice(originalInstallmentPrice);
          return;
        }

        // If we have a valid price and an active discount, proceed with calculation.
        const discountedInstallmentPrice = calculateDiscountedPrice(originalInstallmentPrice, discountPercentage);
        
        const formattedOriginal = formatPrice(originalInstallmentPrice);
        const formattedDiscounted = formatPrice(discountedInstallmentPrice);
        
        // Always overwrite the HTML.
        priceElement.innerHTML = `<s>${formattedOriginal}</s>&nbsp;${formattedDiscounted}`;
      });
    }
  }

  window.applyStrikethroughPrices = updatePrices;

  function handleCartChange() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        let hasItems = cart.item_count > 0;
        let discountFound = false;
        let newDiscountPercentage = defaultDiscountPercentage;

        // Check for cart-level discount applications
        if (cart.cart_level_discount_applications?.length > 0) {
          cart.cart_level_discount_applications.forEach((discountApplication) => {
            if (discountApplication.value !== "") { // Rebuy tiered discount from Shopify functions
              newDiscountPercentage = discountApplication.value;
              discountFound = true;
            
              console.log('discountPercentage: ' + newDiscountPercentage);
            }
          });
          
          if (typeof window.updateSkioPrices === 'function') {
            window.updateSkioPrices(newDiscountPercentage);
          }
        }

        // Check for line-item-level discounts if no cart-level discount found
        if (!discountFound && hasItems) {
          cart.items.forEach((item) => {
            if (item.line_level_discount_allocations?.length > 0) {
              item.line_level_discount_allocations.forEach((allocation) => {
                const discountApplication = allocation.discount_application;
              });
            }
          });
        }

        // Default discount if none found
        if (!discountFound) {
          console.log('No tiered discount found. Reverting to default: ' + newDiscountPercentage);
        }

        // Update global variables
        discountPercentage = newDiscountPercentage;
        window.hasItems = hasItems;
        window.discountPercentage = newDiscountPercentage;
        window.strikethroughDiscountMultiplier = 1 - newDiscountPercentage / 100;

        // Update prices and setup listeners
        updatePrices(newDiscountPercentage);

        if (typeof window.updateSkioPrices === 'function') {
          window.updateSkioPrices(newDiscountPercentage);
          console.log('skio function');
        }

        // Mark as initialized after first successful cart fetch
        isInitialized = true;
      })
      .catch(() => {
        // If cart fetch fails, still mark as initialized and use default discount
        if (!isInitialized) {
          discountPercentage = window.discountPercentage || 0;
          updatePrices(discountPercentage);
          isInitialized = true;
        }
      });
  }

  // Event listeners for cart changes and initial load
  handleCartChange();
  document.addEventListener('rebuy:cart.change', handleCartChange);


  document.addEventListener("rebuy:smartcart.line-item-removed", () => {
    console.log('Line item removed');
    // A short delay helps ensure all Rebuy components are fully rendered.
    setTimeout(handleCartChange, 100); 
  });

  // Event listeners for cart show
  document.addEventListener('rebuy:smartcart.show', () => {
    // A short delay helps ensure all Rebuy components are fully rendered.
    setTimeout(() => {
      updatePrices(discountPercentage);
    }, 100);
  });
  

  // Observe changes in facets wrapper
  const facetsWrapper = document.getElementById('main-collection-filters-remove');
  if (facetsWrapper) {
    const facetsObserver = new MutationObserver(() => {
      setTimeout(() => {
        updatePrices(discountPercentage); 
      }, 500);
    });
    facetsObserver.observe(facetsWrapper, { childList: true, subtree: true });
  }

  // Event listeners for form changes
  const facetForm = document.getElementById('FacetFiltersForm');
  const sortBy = document.getElementById('SortBy');
  const facetFormMobile = document.getElementById('FacetFiltersFormMobile');

  if (facetForm) {
    facetForm.addEventListener('submit', handleFacetFormChange);
    facetForm.addEventListener('change', handleFacetFormChange);
  }

  if (sortBy) {
    sortBy.addEventListener('submit', handleFacetFormChange);
    sortBy.addEventListener('change', handleFacetFormChange);
  }

  if (facetFormMobile) {
    facetFormMobile.addEventListener('submit', handleFacetFormChange);
    facetFormMobile.addEventListener('change', handleFacetFormChange);
  }

  function handleFacetFormChange() {
    const productGrid = document.querySelector('#ProductGridContainer');
    if (productGrid) {
      const observer = new MutationObserver(() => {
        setTimeout(() => {
          updatePrices(discountPercentage);
        //  setupVariantPopoverListeners();
        }, 500);
        observer.disconnect();
      });
      observer.observe(productGrid, { childList: true, subtree: true });

      // Disconnect observer after a timeout to prevent memory leaks
      setTimeout(() => {
        observer.disconnect();
      }, 5000);
    }
  }

  // Event listener for load more button click
  const loadMoreButton = document.getElementById('load-more');
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', () => {
      setTimeout(() => {
        updatePrices(discountPercentage);
      }, 1000);
    });
  }

  // Event listener for toggle-filters-button click
  const toggleFiltersButton = document.getElementById('toggle-filters-button');
  if (toggleFiltersButton) {
    toggleFiltersButton.addEventListener('click', () => {
      setTimeout(() => {
        updatePrices(discountPercentage);
      }, 500);
    });
  }

  // Debounce function to limit the rate of function calls
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Event listener for window resize
  window.addEventListener(
    'resize',
    debounce(() => {
      updatePrices(discountPercentage);
    }, 1000)
  );

  // Mutation Observer for Infinite Scroll & Filtering
  const productGrid = document.getElementById('ProductGridContainer');

  if (productGrid) {
    const observer = new MutationObserver((mutationsList, observer) => { // Pass the observer itself to the callback
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          //console.log('New products detected. Updating prices.');
          observer.disconnect();
          updatePrices(discountPercentage);

          observer.observe(productGrid, { childList: true, subtree: true });

          break;
        }
      }
    });

    // Start observing the target node for configured mutations
    observer.observe(productGrid, { childList: true, subtree: true });
    
  } else {
    console.warn('ProductGridContainer not found for MutationObserver.');
  }

  // Listen for the custom event dispatched by the Skio component
  document.addEventListener('skio::update-selling-plan', (event) => {
    const skioPicker = event.target;
    if (!skioPicker || !skioPicker.shadowRoot) return;

    const addToCartButtons = document.querySelectorAll('#AddToCart, #AddToCart-sticky');
    const selectedContainer = skioPicker.shadowRoot.querySelector('.skio-group-container--selected');
    if (!selectedContainer) return;

    const regularPriceElement = selectedContainer.querySelector('.regular-price');
    let finalPriceElement = selectedContainer.querySelector('[skio-subscription-price]');
    if (!finalPriceElement) {
      finalPriceElement = selectedContainer.querySelector('.sale-price');
    }

    if (!regularPriceElement || !finalPriceElement) return;

    const clonedRegularPrice = regularPriceElement.cloneNode(true);
    clonedRegularPrice.removeAttribute('style');
    const regularPriceHTML = clonedRegularPrice.outerHTML;

    const finalPriceText = finalPriceElement.textContent.trim();
    let finalPriceHTML = '';

    if (finalPriceElement.classList.contains('sale-price')) {
      finalPriceHTML = `<span class="sale-price">${finalPriceText}</span>`;
    } else {
      finalPriceHTML = `<span skio-subscription-price="">${finalPriceText}</span>`;
    }

    const buttonText = 'Add to Bag';
    
    addToCartButtons.forEach(button => {
      button.innerHTML = `${buttonText}&nbsp;-&nbsp;${regularPriceHTML}&nbsp;${finalPriceHTML}`;
    });
  });
  
});